import React, { useEffect, useState } from "react";
import { RouteProps } from "react-router-dom";
import CMEDLoginScreen from "../platforms/cmed/CMEDLoginScreen/CMEDLoginScreen";
import { send } from "../utils/sockets/asyncSocket";
import { createPayload } from "../utils/sockets/payload";
import { v4 as uuidv4 } from "uuid";
import { pubsubEvents } from "../components/helpers/socket/pubsubEvent";
import TermsAndConditionsBackdrop from "../pages/TermsAndConditionsBackdrop";
import OneOverlayLoader from "../utils/component-utils/OverlayLoader/OneOverlayLoader";
import NoCMEDAccessErrorBackdrop from "../utils/component-utils/ErrorBackdrop/NoCMEDAccessErrorBackdrop";
import config from "../components/helpers/socket/config";

// @author E42303 Judhjit Ganguli

interface ProtectedRouteCMEDProps extends RouteProps {
  children: React.ReactNode;
  isCMEDLoggedIn: boolean;
  isUserTermsConditionAccepted: boolean;
  accessToken: any;
  loginResponseStatus: any;
  noCMEDAccess: boolean;
  setIsCMEDProfileSelectionCompleted?: any;
  setIsUserTermsConditionAccepted: any;
  onLogin: any;
}

const ProtectedRouteCMED: React.FC<ProtectedRouteCMEDProps> = ({
  children,
  isCMEDLoggedIn,
  isUserTermsConditionAccepted,
  accessToken,
  loginResponseStatus,
  noCMEDAccess,
  setIsCMEDProfileSelectionCompleted,
  setIsUserTermsConditionAccepted,
  onLogin,
  ...rest
}) => {
  const [userAccounts, setuserAccounts] = useState<Array<any>>([]);

  const [loginFaild, setLoginFailed] = useState([]);

  useEffect(() => {
    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_SUCCESS,
      getLogonResponse,
    );
    PubSub.subscribe(
      pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
      getFailedLogonResponse,
    );
  }, []);

  var getLogonResponse = function (msg: any, data: any) {
    if (data.payload.loginSelection === null) {
      setuserAccounts(data.payload.loginResponse);
    }
  };

  var getFailedLogonResponse = function (msg: any, data: any) {
    setLoginFailed(data?.errors);
  };

  function selectedUserRequest(userID: string) {
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_LOGON_USER_SELECTED,
      requestID: uuidv4(),
      type: "logonUserSelectedRequest",
      payload: {
        selectedUserLoginId: String(userID),
      },
    });
    // TODO: Find a better way to handle this flow, cached login on backend not available immediately
    // so need timeout to allow for this to happen.
    // this.CMEDUserSelectedTimeout = setTimeout(this._requestLogin, 1000)
  }

  async function mapUserNameToIdAndSelect(userName: string) {
    setIsCMEDProfileSelectionCompleted(true);
    for (let index = 0; index < userAccounts.length; index++) {
      if (userAccounts[index].displayText === userName) {
        console.log(userAccounts[index].id);
        selectedUserRequest(userAccounts[index].id);
        await delay(1500);
        send(
          config.socket.channels.TRADING,
          createPayload(config.socket.actions.CMED_LOGON, "loginRequest", {}),
        );
      }
    }
  }

  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <>
      {isUserTermsConditionAccepted !== false ? (
        <>
          {isCMEDLoggedIn ? (
            children
          ) : loginResponseStatus ? (
            <CMEDLoginScreen
              userAccountData={userAccounts}
              mapUserNameToIdAndSelect={mapUserNameToIdAndSelect}
              isCMEDLoggedIn={isCMEDLoggedIn}
              loginFaild={loginFaild}
              viewOnly={false}
              singleFlag={false}
            />
          ) : noCMEDAccess ? (
            <NoCMEDAccessErrorBackdrop errorMessage="Contact the EASE team to get entitlements for CME Direct." />
          ) : (
            <OneOverlayLoader
              loadingText={["Authenticating..."]}
              shouldDisplayLogoAndSlogan={true}
            />
          )}
        </>
      ) : (
        <TermsAndConditionsBackdrop
          onLogin={onLogin}
          setIsUserTermsConditionAccepted={setIsUserTermsConditionAccepted}
        />
      )}
    </>
  );
};
export default ProtectedRouteCMED;
